import { Button, Modal, Space, Tag, Timeline, Tooltip } from "antd"


import { useMemo, useState } from "react";
import dayjs from "dayjs";
import { DATE_FORMAT_DD_MM_YYYY, DOC_STATUS_CANCELLED, DOC_STATUS_REQUESTED } from "../../../constants/constants";
import CloseIcon from "../../../components/icons/CloseIcon";
import Detailltem from "../../Organization/components/Detailltem";
import FileIconSmall from "../../../components/icons/FileIconSmall";
import EyeIcon from "../../../components/icons/EyeIcon";
import DownloadIcon from "../../../components/icons/DownloadIcon";
import PdfViewerModal from "../../components/Modal/PdfViewerModal";

interface Props {
    title: string;
    data: any;
    onClose: () => void;
}
const DocInfoModal = (props: Props) => {
    const { data, title, onClose } = props;

    const [pdfData, setPdfData] = useState<any>({});


    const downloadFile = (path: string) => {
        window.open(path, "_blank");
    };


    const logList = useMemo(() => {
        const items: any[] = [];
        if ([DOC_STATUS_REQUESTED, DOC_STATUS_CANCELLED].includes(data?.status)) {
            items.push({
                children: (
                    <div>
                        <div className="flex gap-x-[4px] items-center">
                            <p className="text-[12px] text-[#475467] m-0">Requested Date:</p>
                            <p className="text-[12px] font-[500] m-0">{dayjs(data?.created_at)?.format(DATE_FORMAT_DD_MM_YYYY)}</p>
                        </div>
                        <div className="flex gap-x-[4px] items-center">
                            <p className="text-[12px] text-[#475467] m-0">Requested By:</p>
                            <p className="text-[12px] font-[500] m-0">{data?.createdBy?.first_name} {data?.createdBy?.last_name}</p>
                        </div>
                    </div>
                )
            })
        } else {
            if (data?.requested_by) {
                items.push(
                    {
                        children: (
                            <div>
                                <div className="flex gap-x-[4px] items-center">
                                    <p className="text-[12px] text-[#475467] m-0">Requested Date:</p>
                                    <p className="text-[12px] font-[500] m-0">{dayjs(data?.requested_at)?.format(DATE_FORMAT_DD_MM_YYYY)}</p>
                                </div>
                                <div className="flex gap-x-[4px] items-center">
                                    <p className="text-[12px] text-[#475467] m-0">Requested By:</p>
                                    <p className="text-[12px] font-[500] m-0 capitalize">{data?.requested_by}</p>
                                </div>
                            </div>
                        )
                    })
            }
            items.push({
                children: (
                    <div>
                        <div className="flex gap-x-[4px]">
                            <p className="text-[12px] text-[#475467] m-0">Uploaded Date:</p>
                            <p className="text-[12px] font-[500] m-0">{dayjs(data?.updated_at)?.format(DATE_FORMAT_DD_MM_YYYY)}</p>
                        </div>
                        <div className="flex gap-x-[4px]">
                            <p className="text-[12px] text-[#475467] m-0">Uploaded By:</p>
                            <p className="text-[12px] font-[500] m-0 capitalize">{data?.uploaded_user}</p>
                        </div>
                    </div>
                )
            }
            )
        }

        return items
    }, [data])

    return (
        <Modal
            open={data && Object.keys(data)?.length > 0}
            title={(
                <div className="flex justify-between items-center">
                    <p className="capitalize text-[14px] font-[500] m-0">Info</p>
                    <Button type="text" icon={<CloseIcon />} className="leading-[12px]" onClick={() => onClose()} />
                </div>
            )
            }
            onCancel={() => onClose()}
            footer={false}
            closeIcon={false}
            width={500}
            classNames={{
                content: "!p-0",
                header: "!px-[20px] !py-[10px]",
                body: "!p-[20px] flex flex-col gap-y-[20px] max-h-[720px] overflow-auto"
            }}
        >
            <div className="flex items-center gap-x-[20x] justify-between">
                <Detailltem
                    label="Document / File Name"
                    value={data?.document_name}
                />
                {
                    data?.status === DOC_STATUS_REQUESTED ? (
                        <Tag bordered={false} color="warning" className="rounded-[16px]">Pending</Tag>
                    ) : (
                        data?.requestedBy ? (
                            <Tag bordered={false} color="success" className="rounded-[16px]">Completed</Tag>
                        ) : (
                            <></>
                        )

                    )
                }
            </div>


            <Detailltem
                label="Description"
                value={data?.description}
            />

            {
                data?.document ? (
                    <div className="w-full">
                        <p className="text-[12px] text-[#475467] mb-[4px]">Uploaded File</p>
                        <div className="flex gap-x-[8px] items-center w-full border border-[#E4E7EC] rounded-[8px] p-[8px]">
                            <FileIconSmall />
                            <p className="m-0 text-[12px] leading-[12px] flex-1">{data?.document_name}</p>
                            <Button type="text" size="small" icon={<EyeIcon />} className="bg-[#EDEDED]" onClick={() => setPdfData({ path: data?.document, name: data?.document_name })} />
                            <Button type="text" size="small" icon={<DownloadIcon />} className="bg-[#EDEDED]" onClick={() => downloadFile(data?.document)} />
                        </div>
                    </div>
                ) : (
                    <></>
                )
            }

            <Timeline
                items={logList}
            />
            <PdfViewerModal
                pdfData={pdfData}
                isPdfOpen={Object.keys(pdfData).length > 0}
                closeModal={() => setPdfData({})}
            />
        </Modal>
    )
}

export default DocInfoModal